import { Injectable, inject, signal } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslationService } from './translation.service';

@Injectable({ providedIn: 'root' })
export class ConnectivityService {
  private readonly snackBar = inject(MatSnackBar);
  private readonly translation = inject(TranslationService);

  private readonly _isOnline = signal(typeof navigator !== 'undefined' ? navigator.onLine : true);
  readonly isOnline = this._isOnline.asReadonly();

  private offlineToastVisible = false;

  init(): void {
    if (typeof window === 'undefined') return;

    window.addEventListener('offline', () => {
      this._isOnline.set(false);
      this.notifyOffline();
    });

    window.addEventListener('online', () => {
      this._isOnline.set(true);
      this.offlineToastVisible = false;
    });
  }

  notifyOffline(): void {
    if (this.offlineToastVisible) return;
    this.offlineToastVisible = true;

    this.snackBar.open(
      this.translation.translate('common.offlineMessage'),
      this.translation.translate('common.close'),
      {
        duration: 6000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        panelClass: ['error-snackbar'],
      },
    );
  }
}